module.exports = __webpack_public_path__ + "static/media/downloads.7ad09091.csv";